<template>
  <div>
    <ul>
      <li>
        <!-- 휴대폰 본인인증 버튼 -->
        <button class="icon" @click="phoneClick">
          <img class="phone" src="@/assets/img/icon/icon_phone.png" alt="" />
        </button>
        <p>휴대폰<span>본인인증</span></p>
      </li>
      <li>
        <!-- 아이핀 본인인증 버튼 -->
        <button class="icon" @click="ipinClick">
          <img class="i-pin" src="@/assets/img/icon/icon_ipin.png" alt="" />
        </button>
        <p>아이핀<span>본인인증</span></p>
      </li>
    </ul>
  </div>
</template>

<script>
let popup; // 팝업창 참조 저장용 변수

export default {
  name: 'Citation',
  props: ['type'], // 인증 타입(예: 회원가입, 예약 등)을 부모로부터 받음
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_URL, // API 베이스 URL 환경변수에서 가져옴
    };
  },
  methods: {
    // 휴대폰 본인인증 버튼 클릭 시 실행
    async phoneClick() {
      // 본인인증 요청 URL 생성 (redirectType 쿼리 포함)
      const url = `${this.apiUrl}/auth/kcb/request?redirectType=${this.type}`;
      // 인증 팝업 열기 (사이즈 고정, 위치 지정)
      popup = window.open(
        url,
        'popupChk',
        'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no'
      );

      // 팝업에서 postMessage 이벤트 수신 대기
      window.onmessage = (e) => {
        // 보안: 메시지 출처가 API URL과 일치할 때만 처리
        if (e.origin === `${this.apiUrl}`) {
          // 메시지 데이터 읽고 특수문자 변환 후 JSON 파싱
          const data = JSON.parse(e.data.replace(/&#34;/gm, '"'));

          // 본인인증 실패 시 알림
          if (data.err === 'true') {
            return alert('본인인증에 실패하였습니다.');
          } else {
            // 인증 성공 시 부모 컴포넌트에 이벤트 emit
            this.$emit('authComplete', 'phone', data);
          }
        }
      };
    },

    // 아이핀 본인인증 버튼 클릭 시 실행 (모동작은 phoneClick과 유사)
    async ipinClick() {
      const url = `${this.apiUrl}/auth/kcb/ipin_request?redirectType=${this.type}`;
      popup = window.open(
        url,
        'popupChk',
        'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no'
      );

      window.onmessage = (e) => {
        if (e.origin === `${this.apiUrl}`) {
          const data = JSON.parse(e.data.replace(/&#34;/gm, '"'));
          if (data.err === 'true') {
            return alert('본인인증에 실패하였습니다.');
          } else {
            this.$emit('authComplete', 'ipin', data);
          }
        }
      };
    },
  },
};
</script>
